import { PaymentMethodVerificationStatus } from '@/modules/transaction/components/ReimburseMe/types/payment.types';
import { storeCreator } from '@/utils/store/store.utils';
  
  
interface State {
  plaidAccountVerificationStatus?: PaymentMethodVerificationStatus;
  accountId?: string;
  additionalAction?: () => void;
  setAccountId: (accountId?: string) => void;
  setPlaidAccountVerificationStatus: (status?: PaymentMethodVerificationStatus) => void;
  setAdditionalAction: (action?: () => void) => void;
  handleReset: () => void;
}
  
export const useStore = storeCreator<State>((set) => ({
  plaidAccountVerificationStatus: undefined,
  accountId: undefined,
  additionalAction: undefined,
  
  setAccountId: (accountId) => set((state) => ({
    ...state,
    accountId,
  })),

  setPlaidAccountVerificationStatus: (status) => set((state) => ({
    ...state,
    plaidAccountVerificationStatus: status,
  })),

  setAdditionalAction: (action) => set((state) => ({
    ...state,
    additionalAction: action,
  })),

  handleReset: () => set((state) => ({
    ...state,
    plaidAccountVerificationStatus: undefined,
    accountId: undefined,
    additionalAction: undefined,
  })),
}));
  